import { render, staticRenderFns } from "./CustomerAccumulationByPartSegment.vue?vue&type=template&id=54fd58ec&scoped=true"
import script from "./CustomerAccumulationByPartSegment.vue?vue&type=script&lang=js"
export * from "./CustomerAccumulationByPartSegment.vue?vue&type=script&lang=js"
import style0 from "./CustomerAccumulationByPartSegment.vue?vue&type=style&index=0&id=54fd58ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fd58ec",
  null
  
)

export default component.exports